import type { ObjectDirective, DirectiveBinding } from 'vue';
import { useUserAction } from '@/composables/useUserAction';

const handlers = new WeakMap<HTMLElement, EventListener>();

export const trackAction: ObjectDirective<HTMLElement, string> = {

  mounted(el, binding: DirectiveBinding<string>) {
    const { registerUserAction } = useUserAction();

    const handler = () => {
      registerUserAction(binding.value);
    };
    handlers.set(el, handler);
    el.addEventListener('click', handler, { passive: true });
  },

  updated(el, binding: DirectiveBinding<string>) {
    if (binding.value !== binding.oldValue) {
      const oldHandler = handlers.get(el);
      if (oldHandler) el.removeEventListener('click', oldHandler);

      const { registerUserAction } = useUserAction();
      const newHandler = () => registerUserAction(binding.value);

      handlers.set(el, newHandler);
      el.addEventListener('click', newHandler, { passive: true });
    }
  },

  beforeUnmount(el) {
    const handler = handlers.get(el);
    if (handler) {
      el.removeEventListener('click', handler);
      handlers.delete(el);
    }
  }
};